import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosErrorHandler } from '@api/config';
import { IClient, PaginatedType } from '@types';
import {
    IClientFavoriteProduct,
    IClientsQuery,
    ITopStats,
} from '@entities/client/model/types';
import {
    getClientRequest,
    getClientsFavoriteProductsRequest,
    getClientsRequest,
    getTopStatsRequest,
    updateClientCommentRequest,
} from '@api/services/clientsApi';

export const getClients = createAsyncThunk<
    PaginatedType<IClient>,
    { shop_id: number; params: IClientsQuery }
>(
    '@@client/getClients',
    async (
        { shop_id, params }: { shop_id: number; params: IClientsQuery },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getClientsRequest(shop_id, params);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);

export const getTopStats = createAsyncThunk<
    ITopStats,
    { period: string; shop_id: number }
>(
    '@@client/getTopStats',
    async (
        { period, shop_id }: { period: string; shop_id: number },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getTopStatsRequest(period, shop_id);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const getClient = createAsyncThunk<
    IClient,
    { shop_id: number; client_id: number }
>(
    '@@client/getClient',
    async (
        { shop_id, client_id }: { shop_id: number; client_id: number },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getClientRequest(client_id, shop_id);
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const getClientsFavoriteProducts = createAsyncThunk<
    IClientFavoriteProduct[],
    { shop_id: number; client_id: number }
>(
    '@@client/getClientsFavoriteProducts',
    async (
        { shop_id, client_id }: { shop_id: number; client_id: number },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await getClientsFavoriteProductsRequest(
                client_id,
                shop_id
            );
            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
export const updateClientComment = createAsyncThunk<
    IClient,
    { shop_id: number; client_id: number; text: string }
>(
    '@@client/updateClientComment',
    async (
        {
            shop_id,
            client_id,
            text,
        }: { shop_id: number; client_id: number; text: string },
        { rejectWithValue }
    ) => {
        try {
            const { data } = await updateClientCommentRequest(
                text,
                client_id,
                shop_id
            );

            return data;
        } catch (err) {
            return rejectWithValue(axiosErrorHandler(err));
        }
    }
);
